import { Box, Button, Title } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Input from 'modules/core/components/Inputs/Text'
import Loading from 'modules/core/components/Loading'
import { PanesPad } from 'modules/core/components/PanesPad'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { usePrompt } from 'modules/core/lib/react-router'

import { NineboxForm, useNineGridBox } from 'modules/competencies/lib/ninegridboxContext'
import ninegridboxessetup from 'modules/competencies/store/collections/ninegridboxessetup'

import Filters from './Filters'
import { UserSelectorInput } from './UserSelectorInput'

const NineForm = () => {
  const { form, loading, loadingSetup, loadingUsers, filteredUsers } = useNineGridBox()
  const {
    access: { id: ownerId },
  } = useCurrentSession()
  const nameXaxis = i18n.t('competencies_v2.ninebox.form.x_axis_title')
  const nameYaxis = i18n.t('competencies_v2.ninebox.form.y_axis_title')

  const saveNineBoxSetup = async () => {
    const xAxisName =
      form.get('x_axis_name').value.length === 0
        ? i18n.t('competencies_v2.ninebox.form.x_axis_placeholder')
        : form.get('x_axis_name').value

    const yAxisName =
      form.get('y_axis_name').value.length === 0
        ? i18n.t('competencies_v2.ninebox.form.y_axis_placeholder')
        : form.get('y_axis_name').value

    form.setValues({
      owner_id: ownerId,
      x_axis_name: xAxisName,
      y_axis_name: yAxisName,
      x_axis_ids: form.get('x_axis_ids').value,
      y_axis_ids: form.get('y_axis_ids').value,
    })

    const { success } = await asyncAction(() => {
      return form.create(ninegridboxessetup)
    })

    if (success) return success
  }

  // TODO: Review this type. It was typed as any before because apparently this NinboxForm
  //       type doesn't have a `saved` property so this is either wrong or it is being evaluated
  //       as undefined.
  usePrompt(
    i18n.t('common.confirm_navigation'),
    () => form.isDirty && !(form as NineboxForm & { saved: boolean }).saved
  )

  if (loading || loadingSetup || loadingUsers) return <Loading />

  return (
    <PanesPad>
      <Box paddingBottom="s32">
        <Title
          illustration="user-interaction-review_chart"
          title={i18n.t('competencies_v2.ninebox.title')}
          description={i18n.t('competencies_v2.ninebox.description')}
          variant="600"
        />
      </Box>
      <Box flexDirection="column" gap="s40">
        {!filteredUsers && (
          <TextField
            readonly
            label={i18n.t('competencies_v2.ninebox.form.employees')}
            description={i18n.t('competencies_v2.ninebox.form.missing_employees')}
            value={i18n.t('user_selector.label.zero')}
          />
        )}
        {filteredUsers && (
          <UserSelectorInput
            label={i18n.t('competencies_v2.ninebox.form.employees')}
            selectedIds={form.get('access_ids').value}
            users={filteredUsers}
            multiselect
          />
        )}
        <Box gap="s4">
          <Input
            field={form.get('x_axis_name')}
            placeholder={i18n.t('competencies_v2.ninebox.form.x_axis_placeholder')}
            label={nameXaxis}
          />
          <Filters isXaxis />
        </Box>
        <Box gap="s4">
          <Input
            field={form.get('y_axis_name')}
            placeholder={i18n.t('competencies_v2.ninebox.form.y_axis_placeholder')}
            label={nameYaxis}
          />
          <Filters isXaxis={false} />
        </Box>
        <Box alignSelf="flexEnd">
          {form?.isDirty && (
            <Button onClick={() => saveNineBoxSetup()}>{i18n.t('common.save')}</Button>
          )}
        </Box>
      </Box>
    </PanesPad>
  )
}

export default observer(NineForm)
